export const findDroppableElement = (droppableId: string): HTMLElement =>
  document.querySelector(`[data-droppableid="${droppableId}"]`);
